import { render, staticRenderFns } from "./website-video.vue?vue&type=template&id=6912169c&scoped=true&"
import script from "./website-video.vue?vue&type=script&lang=js&"
export * from "./website-video.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6912169c",
  null
  
)

export default component.exports